export default __webpack_public_path__ + "static/media/78.dffd3751.png";